export default __webpack_public_path__ + "static/media/SolenoidTypes.24a6a759.jpg";